import styled from 'styled-components';
import { DivContent } from '../../../../components/Section/Content/styles';

export const Container = styled(DivContent)`
  button:first-child svg {
    transform: scaleX(-1);
  }
  .vtr-hero .splide__track {
    padding-top: 24px;
    padding-left: 24px !important;
  }
  .splide__list {
    margin-top: 0;
  }
  .vtr-card {
    width: 216px;
    height: 312px;
  }
  h3 {
    margin: 0;
  }
  .carousel-footer {
    display: flex;
    justify-content: center;
    padding-top: 0 !important;
  }
  @media (min-width: 650px) {
    .carousel-footer {
      display: none;
    }
  }
  @media (max-width: 650px) {
    .carousel-header {
      display: none;
    }
  }
  button {
    > svg {
      display: inline;
    }
  }
`;

export const Button = styled.button`
  background: #f5f6f7;
  border: none;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  margin-left: 6px;
  margin-top: 10px;
  svg {
    fill: #000000;
  }
  &:disabled {
    background: #ffffff;
    svg {
      fill: #ced1d7;
    }
  }
`;
